import { Expose, Transform } from "class-transformer";

export class StartOnboardingSessionDto {
  @Expose()
  token: string;

  @Expose()
  @Transform(({ value }) => (typeof value === "string" ? value.trim().toUpperCase() : value))
  username: string;
}
